import { TaskDueDateOffset } from '../CRMIntegrationTaskSettings'

export type AdvisorEngineInboundContactSyncSettingsFilters = {
  active?: boolean
  contactType?: string
  tags?: string[]
}

export type AdvisorEngineInboundContactSyncSettings = {
  autoSync: boolean
  filters: AdvisorEngineInboundContactSyncSettingsFilters
}

export type AdvisorEngineInboundSyncSettings = {
  contact: AdvisorEngineInboundContactSyncSettings
}

export type AdvisorEngineSettingsFormValues = {
  inbound: AdvisorEngineInboundSyncSettings
  taskDueDateOffset?: TaskDueDateOffset
}

export const AdvisorEngineSettingsDefaultValues: AdvisorEngineSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
      filters: {},
    },
  },
  taskDueDateOffset: {
    value: 1,
    unit: 'weeks',
  },
}
